<span *ngIf="value === 0" class="color-iconDefault" cvLocalizedText langSection="Manage_Reports" langKey="Draft">Draft</span>
<span *ngIf="value === 1" class="color-iconDefault" style="font-style: italic;" cvLocalizedText langSection="Manage_Reports" langKey="Published_Draft">
    Published - Draft
</span>
<span *ngIf="value === 2" cvLocalizedText langSection="Manage_Reports" langKey="Published">Published</span>
<span *ngIf="value === 3" cvLocalizedText langSection="Manage_Reports" langKey="Unpublished">Unpublished</span>
